// Monday, 13 March 2023
// Change this version if you want to invalidate old data
export const DATA_VERSION = '1678706392';

export const CACHE_KEY_REVISION = '2026-10-26';
